<section class="z-[9999] fixed flex items-center justify-center inset-0 w-screen h-screen" [ngClass]="{ 'bg-black/60': hasBackdrop() }">
    
    <div @fadeIn class="bg-white min-w-[30rem] rounded-lg flex flex-col">
        @if(!disableLayout()){
        <div [ngClass]="label() ? 'justify-between' : 'justify-end'" class="flex items-center p-4">
                <div class="flex flex-col gap-1">
                    @if (label(); as label) {
                        <p class="font-semibold text-gray-600 md:text-lg">{{ label }}</p>
                        @if (description(); as description) {
                        <p class="text-sm text-gray-500">{{ description }}</p>
                    }
                }
            </div>

            <button (click)="dialogService.dismiss()">
                <app-icon class="text-gray-500" name="mdi:close" />
            </button>
        </div>
        <app-divider></app-divider>
    }

        <div [class.p-4]="!disableLayout()">
            <ng-template dialog></ng-template>
        </div>
    </div>

</section>
